import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/ui/Button';

const QuickActions = ({ className = '' }) => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 1,
      title: 'Add Staff Member',
      description: 'Register member',
      icon: 'UserPlus',
      variant: 'outline',
      onClick: () => navigate('/staff-management')
    },
    {
      id: 2,
      title: 'Edit Services',
      description: 'Update service catalog',
      icon: 'Wrench',
      variant: 'outline',
      onClick: () => navigate('/service-management')
    },
    {
      id: 3,
      title: 'Business Hours',
      description: 'Modify operating hours',
      icon: 'Clock',
      variant: 'outline',
      onClick: () => navigate('/business-profile-settings')
    },
    {
      id: 4,
      title: 'Update Profile',
      description: 'Edit business details',
      icon: 'Settings',
      variant: 'outline',
      onClick: () => navigate('/business-profile-settings')
    },
    {
      id: 5,
      title: 'Staff Roles',
      description: 'Manage permissions',
      icon: 'Shield',
      variant: 'outline',
      onClick: () => navigate('/staff-management')
    },
    {
      id: 6,
      title: 'Service Pricing',
      description: 'Update service rates',
      icon: 'DollarSign',
      variant: 'outline',
      onClick: () => navigate('/service-management')
    }
  ];

  return (
    <div className={`bg-card rounded-lg p-6 elevation-1 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
        <span className="text-sm text-muted-foreground">Shortcuts</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {quickActions?.map((action) => (
          <Button
            key={action?.id}
            variant={action?.variant}
            onClick={action?.onClick}
            iconName={action?.icon}
            iconPosition="left"
            iconSize={16}
            className="justify-start p-4 h-auto transition-smooth hover:elevation-1 hover:bg-transparent hover:text-cyan-700 hover:border-cyan-700 hover:rounded hover:font-bold"
          >
            <div className="text-left">
              <div className="font-medium text-sm">{action?.title}</div>
              <div className="text-xs text-zinc-700 mt-1">{action?.description}</div>
            </div>
          </Button>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-xs text-muted-foreground text-center">
          Access all management features from the navigation menu
        </p>
      </div>
    </div>
  );
};

export default QuickActions;